import { render } from "./MWGallery.vue?vue&type=template&id=1865d3e1"
import script from "./MWGallery.vue?vue&type=script&lang=js"
export * from "./MWGallery.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__